<cosmos-auth-layout
  [title]="'recovery.title' | translate"
  [subtitle]="'recovery.subtitle' | translate"
>

  <div class="recovery-form">

    <div class="form-fields">
      <p-floatlabel variant="on" class="w-full">
        <input
          pInputText
          id="recovery-email"
          type="email"
          class="w-full"
          [(ngModel)]="email"
          required
          #inputEmail="ngModel"
        />
        <label for="recovery-email">
          <i class="fa-solid fa-envelope me-2"></i>
          {{ 'fields.email' | translate }}
        </label>
      </p-floatlabel>
    </div>

    @if (error()) {
      <p-message severity="error" styleClass="w-full mt-2">
        {{ 'recovery.error' | translate }}
      </p-message>
    }
    @if (success()) {
      <p-message severity="success" styleClass="w-full mt-2">
        {{ 'recovery.success' | translate}}
      </p-message>
    }

    <div class="form-actions mt-2">
      @if (!success()) {
        <button
          pButton
          type="button"
          severity="primary"
          [label]="'button.recover' | translate"
          [loading]="loading()"
          [disabled]="!inputEmail.valid"
          (click)="onClick()"
          class="w-full"
        ></button>
      }

      <!-- Back to login -->
      <div class="form-forgot">
        <a routerLink="/login">{{ 'button.login' | translate }}</a>
      </div>
    </div>

  </div>

</cosmos-auth-layout>
